module.exports = __webpack_public_path__ + "static/media/liftly.033c11f6.png";